let hostLocation: Location;
function setHostLocation(location: Location) {
    hostLocation = location;
}
function getHostLocation(): Location {
    if (!hostLocation) {
        if (typeof window === 'object') {
            hostLocation = window.location;
        } else {
            throw new Error('Host location has not been initialized.');
        }
    }
    return hostLocation;
}
export { setHostLocation, getHostLocation };
